import { ENDPOINTS } from "config/endpoints";
import { useMutation } from "react-query";
import Error from "types/error";
import client from "utils/clients/client";
import { Request } from "types/request";
import { Response } from "types/response";
import { AddPhoneNumberInputs } from "pages/home/Users/model";

export default function useAddPhoneNumber() {
  const addPhoneNumber = (addPhoneNumberInputs: AddPhoneNumberInputs) => {
    const request: Request = {
      url: `${ENDPOINTS.phoneNumber.admin}`,
      config: {
        method: "post",
        data: { data: addPhoneNumberInputs },
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<null>,
    Error,
    AddPhoneNumberInputs
  >(addPhoneNumber, {
    onSettled: () => {},
  });

  return { data, mutate, ...rest };
}
